// import { CURRENCY } from "@/const";
// import stringifyPrice from "@/utils/stringifyPrice";

export default async function (products, buildTotalPrice) {
  /*
  ... (keeping the commented block for reference)
  */
  console.warn("Build summary export is temporarily disabled due to dependency issues.", { products, buildTotalPrice });
  return "";
}
